import React from 'react'
import SbcCommon from './SbcCommon';
import { Stack } from '@mui/material';
import SbcWrapper from './SbcWrapper';

// sidebar panel for calendar
export default function SbcCalendar({
    data,
    handleIptChange,
    handleMultiIptChange,
    handleSwitchChange,
    handleSelectChange
}) {

    return (
        <SbcWrapper>
            <SbcCommon
                data={data}
                handleIptChange={handleIptChange}
                handleMultiIptChange={handleMultiIptChange}
                handleSwitchChange={handleSwitchChange}
                handleSelectChange={handleSelectChange}
            />
        </SbcWrapper>
    )
}
